import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    removeRow(_event) {
        this.element.remove()
    }
}
